import React, { useMemo } from "react";
import {
    CourseItem,
    getPlatformName,
    workState
} from "../../../../../../../../API";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import { Button } from "antd";
import homework from "./img/homework.png";
import sign from "./img/sign.png";
import vote from "./img/vote.png";
import live from "./img/live.png";
import living from "./img/living.png";
import exercise from "./img/exercise.png";
import courseware from "./img/courseware.png";
import { isTrue } from "../../../../../../../../Utils/filter";
import moment from "moment";
import { courseDetailUrl } from "../../../../../../../../API/urls";
import classNames from "classnames";
import { ResultMessage } from "components/ResultMessage";
import SubmitError from "pages/main/components/SubmitError";
import { evaluationStatus } from "../../../../../../../../API/evaluate";
import useNeedEvaluation from "../../../../../../../../Utils/useNeedEvaluation";
import { getMeetingHrefProps } from "../../../../../../unitls";

interface DayCellProps {
    course: CourseItem;
    dateTime: string;
}

export default function DayCell({ course, dateTime }: DayCellProps) {
    const history = useHistory();
    const {
        homeworkStatus,
        lmsCourseNo,
        channelId,
        courseUrl,
        isOpen,
        platformType,
        type: courseType
    } = course;
    const { showModal, StopRouter } = useNeedEvaluation({
        weekTimeId: course?.weekTimeId,
        evaluationId: course?.evaluationId,
        evaluationType: course?.evaluationType
    });
    const alert = useMemo(() => {
        return (
            course?.evaluationStatus === evaluationStatus.NotEvaluated &&
            showModal
        );
    }, [course?.evaluationStatus, showModal]);

    function isHasThirdParty() {
        return isTrue(isOpen) && platformType !== "1";
    }

    const handleGoLive = (
        channelId: string,
        chapterId: string,
        lmsCourseNo: string
    ) => {
        if (!channelId) {
            ResultMessage.error(<SubmitError />, { width: 350 });
        } else {
            if (alert) {
                StopRouter();
            } else {
                window.open(
                    `/student/goToPlay?channelId=${channelId}&userId=${localStorage.getItem(
                        "user"
                    )}&chapterCode=${chapterId}&versionCode=${lmsCourseNo}`
                );
            }
        }
    };

    function itemClickHandler(e: React.MouseEvent<HTMLElement>) {
        const target = e.target as HTMLElement;
        if (target.tagName === "BUTTON") return;
        if (!course) return;
        if (alert) {
            StopRouter();
        } else {
            history.push(
                courseDetailUrl(
                    course.courseNo,
                    course.courseSeq,
                    course.weekTimeId
                )
            );
        }
    }

    //获取时间并且格式化
    const date = moment(dateTime).format("YYYY-MM-DD");
    //课程开始时间
    const before = date + " " + course.beginTime.padStart(5, "0");
    const beforeTime = moment(before);
    //课程结束时间
    const after = date + " " + course.endTime.padStart(5, "0");
    const afterTime = moment(after);

    const renderBadge = useMemo(() => {
        if (afterTime.isBefore(moment())) return 0; // 已结束
        if (beforeTime.isAfter(moment())) return 1; // 未开始
        return 2;
    }, [afterTime, beforeTime]);

    function onSignClick() {
        if (alert) {
            StopRouter();
        } else {
            history.push(
                `/course/detail/${course.courseNo}/${course.courseSeq}/${course.weekTimeId}/signin/${course.signInId}`
            );
        }
    }

    function onVoteClick() {
        if (alert) {
            StopRouter();
        } else {
            history.push(
                `/course/detail/${course.courseNo}/${course.courseSeq}/${course.weekTimeId}/vote/${course.votePaperId}`
            );
        }
    }

    function onExerciseClick() {
        if (alert) {
            StopRouter();
        } else {
            history.push(
                `/course/detail/${course.courseNo}/${course.courseSeq}/${course.weekTimeId}/exercise`
            );
        }
    }

    function homeworkClick() {
        if (alert) {
            StopRouter();
        } else {
            history.push(`/homework`);
        }
    }

    function onCoursewareClick() {
        if (alert) {
            StopRouter();
        } else {
            history.push(
                `/course/detail/${course.courseNo}/${course.courseSeq}/${course.weekTimeId}/courseware`
            );
        }
    }

    function onQuestionclick() {
        if (alert) {
            StopRouter();
        } else {
            history.push(
                `/course/detail/${course.courseNo}/${course.courseSeq}/${course.weekTimeId}/question`
            );
        }
    }

    function otherClick() {
        window.open(`${courseUrl}`);
    }

    const meetingHref = useMemo(() => {
        if (!course) {
            return null;
        }
        return (
            <div className={style.hrefRow}>
                这节课有会议活动，别错过重要信息哦~{" "}
                <a
                    {...getMeetingHrefProps(course)}
                    className={style.hrefButton}>
                    立即进入
                </a>
            </div>
        );
    }, [course]);

    return (
        <div
            style={{ overflow: "hidden" }}
            onClick={itemClickHandler}
            role="button">
            <div
                className={classNames(
                    style.root,
                    style[`state${renderBadge}`]
                )}>
                {isTrue(course.meetingFlag) && meetingHref}
                <div className={style.pd}>
                    <div className={style.courseName}>
                        <div>{course.courseName}</div>
                        <div>
                            {renderBadge === 2 && (
                                <span className={style.living}>
                                    <img
                                        src={living}
                                        style={{ width: "12px" }}
                                    />
                                    正在上课
                                </span>
                            )}
                        </div>
                    </div>

                    <div className={style.address}>地点：{course.address}</div>

                    <div className={style.container}>
                        <div className={style.timeRange}>
                            {course.beginTime} ~ {course.endTime}
                        </div>
                        <div className={style.name}>
                            教师：{course.teacherName}
                        </div>
                    </div>

                    <div className={style.footer}>
                        {course.cousewareStudyStatus !== "0" && (
                            <Button
                                type="primary"
                                ghost
                                className={style.button}
                                onClick={onCoursewareClick}>
                                <img src={courseware} className={style.img} />
                                课件
                            </Button>
                        )}
                        {isTrue(course.questionnaireStatus) && (
                            <Button
                                type="primary"
                                ghost
                                className={style.button}
                                onClick={onQuestionclick}>
                                <img src={courseware} className={style.img} />
                                问卷
                            </Button>
                        )}

                        {/*{!isHasThirdParty() && (*/}
                        {/*    <Button*/}
                        {/*        type="primary"*/}
                        {/*        ghost*/}
                        {/*        className={style.button}*/}
                        {/*        onClick={() =>*/}
                        {/*            handleGoLive(channelId, "", lmsCourseNo)*/}
                        {/*        }>*/}
                        {/*        <img src={live} className={style.img} />*/}
                        {/*        直播*/}
                        {/*    </Button>*/}
                        {/*)}*/}

                        {isTrue(course.signInStatus) && (
                            <Button
                                type="primary"
                                ghost
                                className={style.button}
                                onClick={onSignClick}>
                                <img src={sign} className={style.img} />
                                签到
                            </Button>
                        )}

                        {isTrue(course.votePaperStatus) && (
                            <Button
                                type="primary"
                                ghost
                                className={style.button}
                                onClick={onVoteClick}>
                                <img src={vote} className={style.img} />
                                投票
                            </Button>
                        )}

                        {isTrue(course.studentExerciseStatus) &&
                            isTrue(course.haveExercise) && (
                                <Button
                                    type="primary"
                                    ghost
                                    className={style.button}
                                    onClick={onExerciseClick}>
                                    <img src={exercise} className={style.img} />
                                    练习
                                </Button>
                            )}

                        {homeworkStatus !== workState.NoHomework && (
                            <Button
                                type="primary"
                                ghost
                                className={style.button}
                                onClick={homeworkClick}>
                                <img src={homework} className={style.img} />
                                作业
                            </Button>
                        )}

                        {isHasThirdParty() && (
                            <Button
                                type="primary"
                                ghost
                                className={style.button}
                                onClick={otherClick}>
                                <img src={live} className={style.img} />
                                {getPlatformName(platformType)}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
